<template>
  <a-collapse activeKey="1" ghost>
    <a-collapse-panel key="1" header="商品描述" :show-arrow="false">
      <div class="rich-text-content" v-html="detail"></div>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ProductDescription',
  props: {
    detail: {
      type: String,
      default: ''
    }
  }
});
</script>

<style scoped>
</style>
